import { filterObject } from '../01-core/Utilities';
import { Button, ButtonProps } from '../02-atoms/Button';

export interface ButtonGroupProps {
  /** Button objects */
  items: ButtonProps[];
  /** Compact */
  compact?: boolean;
  /** Spaced */
  spaced?: boolean;
  /** The button type */
  type?: 'primary' | 'secondary' | 'tertiary';
  /** Size */
  size?: 'small' | 'medium' | 'large';
  /** Render icon after label */
  icon_after?: boolean;
  /** Additional class */
  className?: string;
}

/** A group of buttons */
export const ButtonGroup = ({
  items,
  compact,
  spaced,
  type,
  size,
  icon_after,
  className,
  ...props
}: ButtonGroupProps) => {
  if (!items || !items?.length) {
    return null;
  }
  return (
    <span
      className={[
        'btn-group',
        compact && 'btn-group--compact',
        spaced && 'btn-group--spaced',
        type && `btn-group--${type}`,
        className,
      ].join(' ')}
      {...props}
    >
      {items.map((item, i) => {
        return (
          <Button
            key={i}
            type={type || item?.type}
            size={size || item?.size}
            icon_after={icon_after || item?.icon_after}
            {...filterObject(item, [], ['type', 'size', 'icon_after'])}
          />
        );
      })}
    </span>
  );
};
